<template>
  <el-row class="nav-top">
      <el-col :span="6" :class="activeMenu==='1'?'active':''" @click="changeMenu('1')"><p @click="changeMenu('1')">开发者分析</p></el-col>
      <el-col :span="6" :class="activeMenu==='2'?'active':''"><p @click="changeMenu('2')">终端分析</p></el-col>
      <el-col :span="6" :class="activeMenu==='3'?'active':''"><p @click="changeMenu('3')">产品分析</p></el-col>
      <el-col :span="6" :class="activeMenu==='4'?'active':''"><p @click="changeMenu('4')">运营分析</p></el-col>
    </el-row>
</template>
<script>
export default {
  props: {
    curTabProps: {
      type: String,
      default: () => '1'
    }
  },
  data() {
    return {
      activeMenu: '',
    }
  },
  watch: {
    curTabProps: {
      handler(value) {
        this.activeMenu = value;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeMenu(v) {
      this.activeMenu = v;
      if(v==='1') {
        this.$router.push('/dataBoard/developer');
      }else if(v==='2') {
        this.$router.push('/dataBoard/terminal');
      } else if(v==='3') {
        this.$router.push('/dataBoard/product');
      }else if(v==='4') {
        this.$router.push('/dataBoard/operations');
      }
    }
  }
}
</script>
<style lang='scss' scoped>
 .nav-top {
    width: 100%;
    height: 60px;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    background-color: rgba(255, 107, 0, 0.2);
    p{
      width: 100%;
      height: 100%;
      line-height:60px;
      margin: 0;
      color: rgba(255, 107, 0, 1);
    }
    .active {
       background-color: #F28639;
       p {
         color:#fff!important;
       }
     }
 }
 </style>